import React from 'react';
import PropTypes from 'prop-types';
import './three_dots.scss';

class Loader extends React.Component {
  static displayName = 'Loader';

  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    return (
      <div
        className={`Loader ThreeDotsLoader ${this.props.className || ''}`}
        data-testid="loader-overlay"
      >
        <div className="wrap">
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
        </div>
      </div>
    );
  }
}

export default Loader;
